import { Injectable } from '@angular/core';
import { UserService } from '../services/user.service';
import { map } from 'rxjs/operators';


@Injectable()
export class LeasesResolver  {

  constructor(private userService: UserService) {}

  resolve() {
    return this.userService.getLeases(50, 0)
      .pipe(
        map(result => result)
      );
  }
}
